import styled from 'styled-components';
import ArrowIcon from '@src/assets/imgs/arrow.svg';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import useOutsideClick from '@src/hooks/useOutsideClick';
import { devices } from '@src/styles/theme';

type T = {
  value: string;
  label: string;
  type: string;
};

type Props = {
  defaultName: string;
  onChangeFilter: (label: string, type: string) => void;
  ItemList?: Array<T>;
};

const BoardFilterSelector = ({
  defaultName,
  onChangeFilter,
  ItemList,
}: Props) => {
  const [isOpener, setIsOpener] = useState<boolean>(false);
  const filterRef = useRef<HTMLUListElement>(null);

  const onOpener = useCallback(() => {
    setIsOpener(false);
  }, []);

  useOutsideClick(filterRef, () => onOpener());
  return (
    <ButtonWrapper
      ref={filterRef}
      onClick={() => {
        setIsOpener((prev) => !prev);
      }}
    >
      <FilterButton isClick={true}>{defaultName}</FilterButton>
      <FilterOpener isOpener={isOpener} />
      {isOpener && (
        <FilterWrap>
          {ItemList?.map((e, i) => (
            <Filter
              key={i}
              isSelect={e.label === defaultName}
              onClick={() => {
                onChangeFilter(e.label, e.type);
              }}
            >
              {e.label}
            </Filter>
          ))}
        </FilterWrap>
      )}
    </ButtonWrapper>
  );
};

const Filter = styled.button<{ isSelect: boolean }>`
  width: 100%;
  height: 49px;
  background: ${({ isSelect }) => (isSelect ? '#F9F9F9' : '#FEFEFE')};
  border: 1px solid transparent;
  color: ${({ theme, isSelect }) =>
    isSelect ? theme.commonColor.black : theme.commonColor.black};
  cursor: pointer;
  &:first-child {
    border-radius: 10px 10px 0px 0px;
  }
  &:last-child {
    border-radius: 0px 0px 10px 10px;
  }
  z-index: 99;
  &:hover {
    background-color: ${({ theme }) => theme.commonColor.pink004};
    color: ${({ theme }) => theme.commonColor.white};
  }
`;

const ButtonWrapper = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  position: relative;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.commonColor.white};
  border: 1px solid ${({ theme }) => theme.commonColor.gray003};
  padding: 5px 12px;
  cursor: pointer;

  @media ${devices.tablet} {
    padding: 5px 8px;
  }
`;

const FilterWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 27px;
  left: 0;
`;

const FilterButton = styled.li<{ isClick?: boolean }>`
  color: ${({ theme }) => theme.commonColor.gray005};
  list-style: none;
  &::marker {
    color: ${({ theme }) => theme.commonColor.black};
  }
  cursor: ${({ isClick }) => (!isClick ? 'auto' : 'pointer')};
`;

const FilterOpener = styled(({ isOpener, ...props }) => (
  <ArrowIcon {...props} />
))<{ isOpener?: boolean }>`
  & > path {
    stroke: ${({ theme }) => theme.commonColor.gray005};
  }
  cursor: pointer;
  width: 14px;
  height: 14px;
  ${({ isOpener }) =>
    isOpener ? `transform: rotate(-180deg)` : `transform: rotate(0deg)`};
`;

export default BoardFilterSelector;
